// common type
export const ME_GET = 'ME_GET';
export const ME_RESET = 'ME_RESET';

export const USER_ALL = 'USER_ALL';
export const USER_GET = 'USER_GET';
export const USER_POST = 'USER_POST';
export const USER_PUT = 'USER_PUT';
export const USER_DEL = 'USER_DEL';
export const USER_CREATE = 'USER_CREATE';
export const USER_LOADING = 'USER_LOADING';
export const USER_ERROR = 'USER_ERROR';

// feature type

// CRM
export const CUSTOMER_ALL = 'CUSTOMER_ALL';
export const CUSTOMER_GET = 'CUSTOMER_GET';
export const CUSTOMER_POST = 'CUSTOMER_POST';
export const CUSTOMER_PUT = 'CUSTOMER_PUT';
export const CUSTOMER_DEL = 'CUSTOMER_DEL';
export const CUSTOMER_RESET = 'CUSTOMER_RESET';
export const CUSTOMER_LOADING = 'CUSTOMER_LOADING';
export const CUSTOMER_ERROR = 'CUSTOMER_ERROR';

export const CUSTOMER_TYPE_ALL = 'CUSTOMER_TYPE_ALL';
export const CUSTOMER_TYPE_GET = 'CUSTOMER_TYPE_GET';
export const CUSTOMER_TYPE_POST = 'CUSTOMER_TYPE_POST';
export const CUSTOMER_TYPE_PUT = 'CUSTOMER_TYPE_PUT';
export const CUSTOMER_TYPE_DEL = 'CUSTOMER_TYPE_DEL';
export const CUSTOMER_TYPE_LOADING = 'CUSTOMER_TYPE_LOADING';
export const CUSTOMER_TYPE_ERROR = 'CUSTOMER_TYPE_ERROR';

// HRMS
export const DEPARTMENT_ALL = 'DEPARTMENT_ALL';
export const DEPARTMENT_GET = 'DEPARTMENT_GET';
export const DEPARTMENT_POST = 'DEPARTMENT_POST';
export const DEPARTMENT_PUT = 'DEPARTMENT_PUT';
export const DEPARTMENT_DEL = 'DEPARTMENT_DEL';
export const DEPARTMENT_LOADING = 'DEPARTMENT_LOADING';
export const DEPARTMENT_ERROR = 'DEPARTMENT_ERROR';

export const ROLETYPES_ALL = 'ROLETYPES_ALL';
export const ROLETYPES_GET = 'ROLETYPES_GET';
export const ROLETYPES_POST = 'ROLETYPES_POST';
export const ROLETYPES_PUT = 'ROLETYPES_PUT';
export const ROLETYPES_DEL = 'ROLETYPES_DEL';
export const ROLETYPES_LOADING = 'ROLETYPES_LOADING';
export const ROLETYPES_ERROR = 'ROLETYPES_ERROR';

export const EMPLOYEE_ALL = 'EMPLOYEE_ALL';
export const EMPLOYEE_GET = 'EMPLOYEE_GET';
export const EMPLOYEE_POST = 'EMPLOYEE_POST';
export const EMPLOYEE_PUT = 'EMPLOYEE_PUT';
export const EMPLOYEE_DEL = 'EMPLOYEE_DEL';
export const EMPLOYEE_RESET = 'EMPLOYEE_RESET';
export const EMPLOYEE_LOADING = 'EMPLOYEE_LOADING';
export const EMPLOYEE_ERROR = 'EMPLOYEE_ERROR';

// Information
export const INFORMATION_ALL = 'INFORMATION_ALL';
export const INFORMATION_PUT = 'INFORMATION_PUT';
export const INFORMATION_LOADING = 'INFORMATION_LOADING';
export const INFORMATION_ERROR = 'INFORMATION_ERROR';

// IMS
export const MATERIAL_TYPE_ALL = 'MATERIAL_TYPE_ALL';
export const MATERIAL_TYPE_GET = 'MATERIAL_TYPE_GET';
export const MATERIAL_TYPE_POST = 'MATERIAL_TYPE_POST';
export const MATERIAL_TYPE_PUT = 'MATERIAL_TYPE_PUT';
export const MATERIAL_TYPE_DEL = 'MATERIAL_TYPE_DEL';
export const MATERIAL_TYPE_LOADING = 'MATERIAL_TYPE_LOADING';
export const MATERIAL_TYPE_ERROR = 'MATERIAL_TYPE_ERROR';

// IMS

export const MATERIALTYPES_ALL = 'MATERIALTYPES_ALL';
export const MATERIALTYPES_GET = 'MATERIALTYPES_GET';
export const MATERIALTYPES_POST = 'MATERIALTYPES_POST';
export const MATERIALTYPES_PUT = 'MATERIALTYPES_PUT';
export const MATERIALTYPES_DEL = 'MATERIALTYPES_DEL';
export const MATERIALTYPES_LOADING = 'MATERIALTYPES_LOADING';
export const MATERIALTYPES_ERROR = 'MATERIALTYPES_ERROR';

export const MATERIAL_ALL = 'MATERIAL_ALL';
export const MATERIAL_GET = 'MATERIAL_GET';
export const MATERIAL_POST = 'MATERIAL_POST';
export const MATERIAL_PUT = 'MATERIAL_PUT';
export const MATERIAL_DEL = 'MATERIAL_DEL';
export const MATERIAL_LOADING = 'MATERIAL_LOADING';
export const MATERIAL_ERROR = 'MATERIAL_ERROR';

export const MATERIAL_TRANSACTION_TYPES_ALL = 'MATERIAL_TRANSACTION_TYPES_ALL';
export const MATERIAL_TRANSACTION_TYPES_GET = 'MATERIAL_TRANSACTION_TYPES_GET';
export const MATERIAL_TRANSACTION_TYPES_POST =
  'MATERIAL_TRANSACTION_TYPES_POST';
export const MATERIAL_TRANSACTION_TYPES_PUT = 'MATERIAL_TRANSACTION_TYPES_PUT';
export const MATERIAL_TRANSACTION_TYPES_DEL = 'MATERIAL_TRANSACTION_TYPES_DEL';
export const MATERIAL_TRANSACTION_TYPES_LOADING =
  'MATERIAL_TRANSACTION_TYPES_LOADING';
export const MATERIAL_TRANSACTION_TYPES_ERROR =
  'MATERIAL_TRANSACTION_TYPES_ERROR';

export const MATERIAL_REQUEST_ALL = 'MATERIAL_REQUEST_ALL';
export const MATERIAL_REQUEST_GET = 'MATERIAL_REQUEST_GET';
export const MATERIAL_REQUEST_POST = 'MATERIAL_REQUEST_POST';
export const MATERIAL_REQUEST_PUT = 'MATERIAL_REQUEST_PUT';
export const MATERIAL_REQUEST_DEL = 'MATERIAL_REQUEST_DEL';
export const MATERIAL_REQUEST_LOADING = 'MATERIAL_REQUEST_LOADING';
export const MATERIAL_REQUEST_ERROR = 'MATERIAL_REQUEST_ERROR';

export const MATERIAL_WITHDRAW_ALL = 'MATERIAL_WITHDRAW_ALL';
export const MATERIAL_WITHDRAW_GET = 'MATERIAL_WITHDRAW_GET';
export const MATERIAL_WITHDRAW_POST = 'MATERIAL_WITHDRAW_POST';
export const MATERIAL_WITHDRAW_PUT = 'MATERIAL_WITHDRAW_PUT';
export const MATERIAL_WITHDRAW_DEL = 'MATERIAL_WITHDRAW_DEL';
export const MATERIAL_WITHDRAW_LOADING = 'MATERIAL_WITHDRAW_LOADING';
export const MATERIAL_WITHDRAW_ERROR = 'MATERIAL_WITHDRAW_ERROR';

export const PLACE_ALL = 'PLACE_ALL';
export const PLACE_GET = 'PLACE_GET';
export const PLACE_POST = 'PLACE_POST';
export const PLACE_PUT = 'PLACE_PUT';
export const PLACE_DEL = 'PLACE_DEL';
export const PLACE_LOADING = 'PLACE_LOADING';
export const PLACE_ERROR = 'PLACE_ERROR';

export const MATERIAL_TRANSACTION_ALL = 'MATERIAL_TRANSACTION_ALL';
export const MATERIAL_TRANSACTION_GET = 'MATERIAL_TRANSACTION_GET';
export const MATERIAL_TRANSACTION_POST = 'MATERIAL_TRANSACTION_POST';
export const MATERIAL_TRANSACTION_PUT = 'MATERIAL_TRANSACTION_PUT';
export const MATERIAL_TRANSACTION_DEL = 'MATERIAL_TRANSACTION_DEL';
export const MATERIAL_TRANSACTION_SEARCH = 'MATERIAL_TRANSACTION_SEARCH';
export const MATERIAL_TRANSACTION_LOADING = 'MATERIAL_TRANSACTION_LOADING';
export const MATERIAL_TRANSACTION_ERROR = 'MATERIAL_TRANSACTION_ERROR';

export const MATERIAL_STOCK_LOT_ALL = 'MATERIAL_STOCK_LOT_ALL';
export const MATERIAL_STOCK_LOT_GET = 'MATERIAL_STOCK_LOT_GET';
export const MATERIAL_STOCK_LOT_POST = 'MATERIAL_STOCK_LOT_POST';
export const MATERIAL_STOCK_LOT_PUT = 'MATERIAL_STOCK_LOT_PUT';
export const MATERIAL_STOCK_LOT_DEL = 'MATERIAL_STOCK_LOT_DEL';
export const MATERIAL_STOCK_LOT_LOADING = 'MATERIAL_STOCK_LOT_LOADING';
export const MATERIAL_STOCK_LOT_ERROR = 'MATERIAL_STOCK_LOT_ERROR';
export const MATERIAL_STOCK_LOT_DECREASE = 'MATERIAL_STOCK_LOT_DECREASE';
export const MATERIAL_STOCK_LOT_INCREASE = 'MATERIAL_STOCK_LOT_INCREASE';

// Notify

export const NOTIFY_REQ_TOKEN = 'NOTIFY_REQ_TOKEN';
export const NOTIFY_DIRECT = 'NOTIFY_DIRECT';
export const NOTIFY_DEPARTMENT = 'NOTIFY_DEPARTMENT';
export const NOTIFY_LOADING = 'NOTIFY_LOADING';
export const NOTIFY_ERROR = 'NOTIFY_ERROR';

// MMS

export const MAINTENANCE_PROCESS_ALL = 'MAINTENANCE_PROCESS_ALL';
export const MAINTENANCE_PROCESS_GET = 'MAINTENANCE_PROCESS_GET';
export const MAINTENANCE_PROCESS_POST = 'MAINTENANCE_PROCESS_POST';
export const MAINTENANCE_PROCESS_PUT = 'MAINTENANCE_PROCESS_PUT';
export const MAINTENANCE_PROCESS_DELETE = 'MAINTENANCE_PROCESS_DELETE';
export const MAINTENANCE_PROCESS_ERROR = 'MAINTENANCE_PROCESS_ERROR';
export const MAINTENANCE_PROCESS_LOADING = 'MAINTENANCE_PROCESS_LOADING';
export const MAINTENANCE_PROCESS_RESET = 'MAINTENANCE_PROCESS_RESET';

export const COMMENT_ALL = 'COMMENT_ALL';
export const COMMENT_GET = 'COMMENT_GET';
export const COMMENT_POST = 'COMMENT_POST';
export const COMMENT_PUT = 'COMMENT_PUT';
export const COMMENT_DELETE = 'COMMENT_DELETE';
export const COMMENT_ERROR = 'COMMENT_ERROR';
export const COMMENT_LOADING = 'COMMENT_LOADING';
export const COMMENT_RESET = 'COMMENT_RESET';

export const PROCESS_TRANSACTION_ALL = 'PROCESS_TRANSACTION_ALL';
export const PROCESS_TRANSACTION_GET = 'PROCESS_TRANSACTION_GET';
export const PROCESS_TRANSACTION_POST = 'PROCESS_TRANSACTION_POST';
export const PROCESS_TRANSACTION_PUT = 'PROCESS_TRANSACTION_PUT';
export const PROCESS_TRANSACTION_DELETE = 'PROCESS_TRANSACTION_DELETE';
export const PROCESS_TRANSACTION_LOADING = 'PROCESS_TRANSACTION_LOADING';
export const PROCESS_TRANSACTION_ERROR = 'PROCESS_TRANSACTION_ERROR';
export const PROCESS_TRANSACTION_RESET = 'PROCESS_TRANSACTION_RESET';

export const PROCESS_MATERIAL_ALL = 'PROCESS_MATERIAL_ALL';
export const PROCESS_MATERIAL_GET = 'PROCESS_MATERIAL_GET';
export const PROCESS_MATERIAL_POST = 'PROCESS_MATERIAL_POST';
export const PROCESS_MATERIAL_PUT = 'PROCESS_MATERIAL_PUT';
export const PROCESS_MATERIAL_DELETE = 'PROCESS_MATERIAL_DELETE';
export const PROCESS_MATERIAL_LOADING = 'PROCESS_MATERIAL_LOADING';
export const PROCESS_MATERIAL_ERROR = 'PROCESS_MATERIAL_ERROR';
export const PROCESS_MATERIAL_RESET = 'PROCESS_MATERIAL_RESET';

// jms

export const BILL_HEADER_ALL = 'BILL_HEADER_ALL';
export const BILL_HEADER_GET = 'BILL_HEADER_GET';
export const BILL_HEADER_POST = 'BILL_HEADER_POST';
export const BILL_HEADER_PUT = 'BILL_HEADER_PUT';
export const BILL_HEADER_DELETE = 'BILL_HEADER_DELETE';
export const BILL_HEADER_LOADING = 'BILL_HEADER_LOADING';
export const BILL_HEADER_ERROR = 'BILL_HEADER_ERROR';
export const BILL_HEADER_RESET = 'BILL_HEADER_RESET';

//gold
export const GOLD_TRANSACTION_GET = 'GOLD_TRANSACTION_GET';
export const GOLD_TRANSACTION_GET_HISTORY = 'GOLD_TRANSACTION_GET_HISTORY';
export const GOLD_TRANSACTION_POST = 'GOLD_TRANSACTION_POST';
export const GOLD_TRANSACTION_ALL = 'GOLD_TRANSACTION_ALL';
export const GOLD_TRANSACTION_PUT = 'GOLD_TRANSACTION_PUT';
export const GOLD_TRANSACTION_DEL = 'GOLD_TRANSACTION_DEL';
export const GOLD_TRANSACTION_DECREASE = 'GOLD_TRANSACTION_DECREASE';
export const GOLD_TRANSACTION_LOADING = 'GOLD_TRANSACTION_LOADING';
export const GOLD_TRANSACTION_ERROR = 'GOLD_TRANSACTION_ERROR';
export const GOLD_TRANSACTION_RESET = 'GOLD_TRANSACTION_RESET';
export const GOLD_TRANSACTION_SUMMARY_MONTHLY =
  'GOLD_TRANSACTION_SUMMARY_MONTHLY';

export const GOLDPRICE_ALL = 'GOLDPRICE_ALL';
export const GOLDPRICE_GET = 'GOLDPRICE_GET';
export const GOLDPRICE_POST = 'GOLDPRICE_POST';
export const GOLDPRICE_PUT = 'GOLDPRICE_PUT';
export const GOLDPRICE_DELETE = 'GOLDPRICE_DELETE';
export const GOLDPRICE_LOADING = 'GOLDPRICE_LOADING';
export const GOLDPRICE_ERROR = 'GOLDPRICE_ERROR';
export const GOLDPRICE_RESET = 'GOLDPRICE_RESET';

export const GOLD_REPORT_GET = 'GOLD_REPORT_GET';
export const GOLD_REPORT_POST = 'GOLD_REPORT_POST';
export const GOLD_REPORT_ALL = 'GOLD_REPORT_ALL';
export const GOLD_REPORT_PUT = 'GOLD_REPORT_PUT';
export const GOLD_REPORT_DEL = 'GOLD_REPORT_DEL';
export const GOLD_REPORT_LOADING = 'GOLD_REPORT_LOADING';
export const GOLD_REPORT_ERROR = 'GOLD_REPORT_ERROR';
export const GOLD_REPORT_RESET = 'GOLD_REPORT_RESET';

export const LOG_TRANSACTION_GET = 'LOG_TRANSACTION_GET';
export const LOG_TRANSACTION_POST = 'LOG_TRANSACTION_POST';
export const LOG_TRANSACTION_ALL = 'LOG_TRANSACTION_ALL';
export const LOG_TRANSACTION_PUT = 'LOG_TRANSACTION_PUT';
export const LOG_TRANSACTION_DEL = 'LOG_TRANSACTION_DEL';
export const LOG_TRANSACTION_LOADING = 'LOG_TRANSACTION_LOADING';
export const LOG_TRANSACTION_ERROR = 'LOG_TRANSACTION_ERROR';
export const LOG_TRANSACTION_RESET = 'LOG_TRANSACTION_RESELOG';

export const PAYMENT_OTHER_ALL = 'PAYMENT_OTHER_ALL';
export const PAYMENT_OTHER_GET = 'PAYMENT_OTHER_GET';
export const PAYMENT_OTHER_POST = 'PAYMENT_OTHER_POST';
export const PAYMENT_OTHER_PUT = 'PAYMENT_OTHER_PUT';
export const PAYMENT_OTHER_DELETE = 'PAYMENT_OTHER_DEL';
export const PAYMENT_OTHER_RESET = 'PAYMENT_OTHER_RESET';
export const PAYMENT_OTHER_LOADING = 'PAYMENT_OTHER_LOADING';
export const PAYMENT_OTHER_ERROR = 'PAYMENT_OTHER_ERROR';

export const DAY_SUMMARY_ALL = 'DAY_SUMMARY_ALL';
export const DAY_SUMMARY_GET = 'DAY_SUMMARY_GET';
export const DAY_SUMMARY_POST = 'DAY_SUMMARY_POST';
export const DAY_SUMMARY_PUT = 'DAY_SUMMARY_PUT';
export const DAY_SUMMARY_LOADING = 'DAY_SUMMARY_LOADING';
export const DAY_SUMMARY_ERROR = 'DAY_SUMMARY_ERROR';

export const DAY_SUMMARY_LIST_ALL = 'DAY_SUMMARY_LIST_ALL';
export const DAY_SUMMARY_LIST_GET = 'DAY_SUMMARY_LIST_GET';
export const DAY_SUMMARY_LIST_POST = 'DAY_SUMMARY_LIST_POST';
export const DAY_SUMMARY_LIST_PUT = 'DAY_SUMMARY_LIST_PUT';
export const DAY_SUMMARY_LIST_LOADING = 'DAY_SUMMARY_LIST_LOADING';
export const DAY_SUMMARY_LIST_ERROR = 'DAY_SUMMARY_LIST_ERROR';

export const MONTH_SUMMARY_ALL = 'MONTH_SUMMARY_ALL';
export const MONTH_SUMMARY_GET = 'MONTH_SUMMARY_GET';
export const MONTH_SUMMARY_POST = 'MONTH_SUMMARY_POST';
export const MONTH_SUMMARY_PUT = 'MONTH_SUMMARY_PUT';
export const MONTH_SUMMARY_LOADING = 'MONTH_SUMMARY_LOADING';
export const MONTH_SUMMARY_ERROR = 'MONTH_SUMMARY_ERROR';

//Bank
export const BANK_ALL = 'BANK_ALL';
export const BANK_GET = 'BANK_GET';
export const BANK_POST = 'BANK_POST';
export const BANK_PUT = 'BANK_PUT';
export const BANK_DEL = 'BANK_DEL';
export const BANK_LOADING = 'BANK_LOADING';
export const BANK_ERROR = 'BANK_ERROR';

export const FINANCE_ALL = 'FINANCE_ALL';
export const FINANCE_GET = 'FINANCE_GET';
export const FINANCE_POST = 'FINANCE_POST';
export const FINANCE_PUT = 'FINANCE_PUT';
export const FINANCE_DEL = 'FINANCE_DEL';
export const FINANCE_LOADING = 'FINANCE_LOADING';
export const FINANCE_ERROR = 'FINANCE_ERROR';
